import styled from "styled-components"
import { Loader } from "~/ur-react-components"
import { useOrganizationMembership } from "~/utils/hooks/useOrganizationMembership"
import { trpc } from "~/utils/trpc"
import SubscriptionSchoolActive from "./SubscriptionSchoolActive"
import SubscriptionSchoolCancelled from "./SubscriptionSchoolCancelled"
import SubscriptionSchoolNoSubscription from "./SubscriptionSchoolNoSubscription"
import SubscriptionSchoolTrialing from "./SubscriptionSchoolTrialing"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 456px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`

export type SubscriptionSchoolProps = {}

const SubscriptionSchool: React.FC<SubscriptionSchoolProps> = () => {
  const organizationMembership = useOrganizationMembership()!

  const { data: schoolSubscription, isLoading } =
    trpc.subscriptions.getOrganizationSubscription.useQuery(
      organizationMembership.organizationId,
    )

  if (
    (!isLoading && !schoolSubscription) ||
    schoolSubscription?.status === "CANCELLED"
  ) {
    return <SubscriptionSchoolNoSubscription />
  }

  if (isLoading || !schoolSubscription) {
    return (
      <Layout>
        <Card>
          <Loader.Spinner />
        </Card>
      </Layout>
    )
  }

  if (schoolSubscription.cancelsAt !== null) {
    return <SubscriptionSchoolCancelled subscription={schoolSubscription} />
  }

  if (schoolSubscription.status === "TRIALING") {
    return (
      <SubscriptionSchoolTrialing schoolSubscription={schoolSubscription} />
    )
  } else {
    return <SubscriptionSchoolActive schoolSubscription={schoolSubscription} />
  }
}

export default SubscriptionSchool
